import { EntryStatusEnum, StageTypeEnum } from '@clubspark-node/clubspark-tennis-types';
import { governors, type HydratedMatchUp, mocksEngine } from 'tods-competition-factory';

import { getClientConfig } from 'config/clients';
import { venueProfiles } from 'mocks/demoTournaments/demoTournaments';

const { queryGovernor } = governors;
const { MAIN } = StageTypeEnum;
const { DIRECT_ACCEPTANCE } = EntryStatusEnum;

export const generateStubHydratedMatchUp = (startDate: string, participantsEntryStatus?: EntryStatusEnum) => {
  const drawId = 'mockDrawId';
  const drawProfiles = [
    {
      eventName: `WTN 14-19 SINGLES`,
      category: { ratingType: 'WTN', ratingMin: 14, ratingMax: 19.99 },
      generate: true,
      drawSize: 4,
      drawId,
    },
  ];
  const schedulingProfile = [
    {
      scheduleDate: startDate,
      venues: [
        {
          venueId: venueProfiles[0].venueId,
          courtId: venueProfiles[0].courtIds[0],
          rounds: [{ drawId, winnerFinishingPositionRange: '1-2' }],
        },
      ],
    },
  ];

  const personExtensions = Object.entries(getClientConfig()?.mockPersonExtensions ?? []).map(([name, value]) => ({
    name,
    value,
  }));
  const participantsProfile = {
    personData: getClientConfig()?.mockParticipants,
    scaledParticipantsCount: 20,
    personExtensions,
  };

  const { tournamentRecord } = mocksEngine.generateTournamentRecord({
    scheduleCompletedMatchUps: true,
    completeAllMatchUps: true,
    hydrateCollections: true,
    participantsProfile,
    autoSchedule: true,
    schedulingProfile: startDate ? schedulingProfile : undefined,
    venueProfiles,
    drawProfiles,
    startDate,
  });

  const contextProfile = { withScaleValues: true, withCompetitiveness: true };
  const {
    matchUps: [mockedMatchUp],
  } = queryGovernor.allTournamentMatchUps({
    tournamentRecord,
    contextProfile,
  }) ?? { matchUps: [{}] as [HydratedMatchUp] };

  return {
    ...mockedMatchUp,
    schedule: { ...mockedMatchUp.schedule },
    sides: mockedMatchUp.sides.map((side, index) => ({
      ...side,
      participant: {
        ...side?.participant,
        ...(participantsEntryStatus && { entryStatus: participantsEntryStatus }),
        teams: [...(side?.participant?.teams ?? []), { participantName: `Team ${index + 1}` }],
      },
    })),
  };
};

export const generateMockDrawEntries = (count = 3, entryStage = MAIN, entryStatus = DIRECT_ACCEPTANCE) =>
  Array(count)
    .fill(0)
    .map((_, i) => ({
      participantId: `participantId${i}`,
      entryPosition: i,
      entryStage,
      entryStatus,
    }));

export const generateMockFlights = (count = 3, drawDefinition = true, drawEntries = generateMockDrawEntries) =>
  Array(count)
    .fill(0)
    .map((_, i = 1) => ({
      flightNumber: i,
      flightName: `Flight ${i}`,
      drawId: `drawId${i}`,
      drawName: `Draw ${i}`,
      ...(drawDefinition && { drawDefinition: { drawId: `drawId${i}` } }),
      drawEntries: drawEntries(),
    }));
